import moment from 'moment';

type GetVisitTimeParams = {
  admissionTime?: string;
  carEntryTime?: number;
  faceEntryTime?: number;
};

export const getVisitTime = ({
  admissionTime,
  carEntryTime,
  faceEntryTime,
}: GetVisitTimeParams) => {
  const times: number[] = [];
  if (admissionTime) {
    times.push(moment(admissionTime).valueOf());
  }
  if (carEntryTime) {
    times.push(carEntryTime);
  }
  if (faceEntryTime) {
    times.push(faceEntryTime);
  }

  if (times.length === 0) {
    return '無紀錄';
  }

  const earliestTime = Math.min(...times);

  return moment(earliestTime).format('YYYY-MM-DD HH:mm:ss');
};
